import sortViews from '@opsbase/lib-data-view/helpers/sortViews';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useViewRegistry from '@opsbase/web-ctrl-view/useViewRegistry';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import React, { useMemo } from 'react';
import ReportsListItem from './ReportsListItem';
export function ReportsList(props) {
    const { viewId, dataType } = props;
    const views = useViewRegistry();
    const self = useSelf();
    const myViews = useMemo(() => sortViews(Object.values(views)
        .filter(v => !v.isDashboard)
        .filter(v => v.type === dataType), self), [dataType, self, views]);
    return (React.createElement(Vertical, null,
        React.createElement(Pane, { grow: true, style: { position: 'relative' }, scroll: true }, myViews.map((lmss, idx) => (React.createElement(ReportsListItem, { key: 'report' + lmss.id, lmss: lmss, idx: idx }))))));
}
export default ReportsList;
